// See https://swr.vercel.app/docs/revalidation for more details on these options
export const RevalidationStrategy = {
    ColdDataPolicy: {
        // These options make the data immutable, meaning it will not be revalidated after the initial fetch
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnMount: true,
        revalidateOnReconnect: false,
    },
    WarmDataPolicy: {
        // With these options, the data will only be revalidated on reconnection, in addition to the initial fetch
        // The revalidateIfStale is set to true to avoid blocking data retrieval on reconnect
        revalidateIfStale: true,
        revalidateOnFocus: false,
        revalidateOnMount: true,
        revalidateOnReconnect: true,
    },
    HotDataPolicy: {
        // With these options, the data will only be retrieved on focus or reconnect
        // The revalidateIfStale is set to true to avoid blocking data retrieval on focus or reconnect
        // /!\ For hooks that use this policy, data will not be retrieved on mount, as it is returned by the user/session route
        revalidateIfStale: true,
        revalidateOnFocus: true,
        revalidateOnMount: false,
        revalidateOnReconnect: true,
    },
};
